var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyprojectLineGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32767 12.8621C2.98616 10.4887 2.81542 9.30206 3.30183 8.28745C3.78824 7.27284 4.82357 6.6561 6.89422 5.42263L8.14057 4.68018C10.0209 3.56006 10.9611 3 12 3C13.0389 3 13.9791 3.56006 15.8594 4.68018L17.1058 5.42263C19.1764 6.6561 20.2118 7.27284 20.6982 8.28745C21.1846 9.30206 21.0138 10.4887 20.6723 12.8621L20.4214 14.6057C19.9828 17.6544 19.7634 19.1787 18.7059 20.0894C17.6483 21 16.0974 21 12.9955 21H11.0045C7.90263 21 6.35168 21 5.29412 20.0894C4.23657 19.1787 4.01723 17.6544 3.57855 14.6057L3.32767 12.8621Z",
    stroke: "#7E969F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C9.85038 16.6303 10.8846 17 12 17C13.1154 17 14.1496 16.6303 15 16",
    stroke: "#7E969F",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyprojectLineGrey);
export default __webpack_public_path__ + "static/media/icon_myproject_line_grey.7f4a8b8add1cdbbbe163ac3a8efa1c2b.svg";
export { ForwardRef as ReactComponent };